import { render, staticRenderFns } from "./PostageROITable.vue?vue&type=template&id=714111af&scoped=true&"
import script from "./PostageROITable.vue?vue&type=script&lang=js&"
export * from "./PostageROITable.vue?vue&type=script&lang=js&"
import style0 from "./PostageROITable.vue?vue&type=style&index=0&id=714111af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714111af",
  null
  
)

export default component.exports